import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 8l2 5l2 -5","key":"svg-0"}],["path",{"d":"M12 16v-3","key":"svg-1"}]]

/**
 * IconLetterYSmall
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbGV0dGVyLXktc21hbGwiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTEwIDhsMiA1bDIgLTUiIC8+CiAgPHBhdGggZD0iTTEyIDE2di0zIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/letter-y-small
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconLetterYSmall = createReactComponent('outline', 'letter-y-small', 'LetterYSmall', __iconNode);

export default IconLetterYSmall;